import { toast } from 'react-toastify';

class NotificationService {
  constructor() {
    this.notificationPermission = false;
    this.scheduledNotifications = new Map();
    this._init();
  }

  _init() {
    // Check if browser supports notifications
    if (!("Notification" in window)) {
      console.log("This browser does not support notifications");
      return;
    }
    
    // Check if permission already granted
    if (Notification.permission === "granted") {
      this.notificationPermission = true;
    }
  }

  async requestPermission() {
    if (Notification.permission !== "granted" && Notification.permission !== "denied") {
      const permission = await Notification.requestPermission();
      this.notificationPermission = permission === "granted";
      return this.notificationPermission;
    }
    return Notification.permission === "granted";
  }

  async scheduleNotification(id, title, body, scheduledTime) {
    if (!this.notificationPermission) {
      const hasPermission = await this.requestPermission();
      if (!hasPermission) {
        toast.warning("Notification permission is required to set reminders");
        return false;
      }
    }
    
    const now = new Date();
    const notificationTime = new Date(scheduledTime);
    const timeUntilNotification = notificationTime.getTime() - now.getTime();
    
    if (timeUntilNotification <= 0) {
      toast.info("Cannot schedule notifications in the past");
      return false;
    }
    
    // Clear existing notification (if any)
    this.cancelNotification(id);
    
    // Schedule the new notification
    const timerId = setTimeout(() => {
      this._showNotification(title, body);
      this.scheduledNotifications.delete(id);
    }, timeUntilNotification);
    
    this.scheduledNotifications.set(id, timerId);
    
    toast.success("Reminder set successfully");
    return true;
  }

  cancelNotification(id) {
    if (this.scheduledNotifications.has(id)) {
      clearTimeout(this.scheduledNotifications.get(id));
      this.scheduledNotifications.delete(id);
      return true;
    }
    return false;
  }

  isScheduled(id) {
    return this.scheduledNotifications.has(id);
  }

  _showNotification(title, body) {
    if (this.notificationPermission) {
      const notification = new Notification(title, {
        body,
        icon: '/favicon.ico'
      });
      
      notification.onclick = () => {
        window.focus();
        notification.close();
      };
    } else {
      toast.info(`${title}: ${body}`);
    }
  }
}

const notificationService = new NotificationService();
export default notificationService;